import React from 'react';
import "./css/Main.css";
import SEO from "../components/SEO";
import HeroSection from "../components/HeroSection";
import HeroGrid from "../components/HeroGrid";
import PopularLocations from '../components/PopularLocation';
import PopularLocations_2 from '../components/PopularLocation_2';
import Accomplishment from "../components/Accomplishment";
import PopularTrips from "../components/PopularTrips.js";
import HomeGallery from '../components/HomeGallery';
import Footer from "../components/Footer";
import FancyGrid from '../components/FancyGrid.js';

function Home() {
  return (
    <>
      <SEO
        title="Joujo Safaris | Luxury Safari Tours in Kenya & Africa"
        description="Book luxury safaris with Joujo Safaris. Explore Kenya, Tanzania, and Africa's Big Five adventures, cultural tours, and tailor-made safari packages for unforgettable journeys."
        url="https://joujosafaris.com/"
        image="https://www.joujosafaris.com/static/media/37.2020e3700d3295e7ac77.jpg"
        keywords="Kenya safari tours, luxury safaris Africa, Big Five adventures, Maasai Mara safaris, Serengeti tours, cultural safaris Kenya, Joujo Safaris"
      />

      {/* ✅ JSON-LD Structured Data for Homepage */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "TravelAgency",
          "name": "Joujo Safaris",
          "url": "https://joujosafaris.com",
          "logo": "https://joujosafaris.com/assets/logo.png",
          "image": "https://joujosafaris.com/assets/masai-mara.jpg",
          "description":
            "Joujo Safaris offers luxury safaris, Big Five tours, and cultural experiences across Kenya and Africa. Tailor-made safari packages for unforgettable adventures.",
          "address": {
            "@type": "PostalAddress",
            "addressCountry": "Kenya"
          },
          "areaServed": ["Kenya", "Tanzania", "Uganda", "Rwanda", "Africa"],
          "sameAs": [
            "https://x.com/SafarisJoujo",
            "https://www.facebook.com/J0ujosafaris/",
            "https://www.instagram.com/joujo_safaris/"
          ]
        })}
      </script>

      <HeroSection />
      <HeroGrid />

      <div className="home-title">
        <h2>Popular Packages</h2>
        <p>The Destinations</p>
      </div>

      {/* <PopularTrips />
      <PopularTrips /> */}
      <PopularLocations />

      <Accomplishment />
      <FancyGrid />

      <div className="home-title" style={{ marginTop: "70px" }}>
        <h2>Popular Locations</h2>
        <p>More To Explore</p>
      </div>

      <PopularLocations_2 />
      <HomeGallery />
      <Footer />
    </>
  );
}

export default Home;
